import { Stack } from '@mui/material';
import Error404 from 'v2/views/components/error/error404';
import { WorkspaceSettingDetailView } from '../WorkspaceSettingDetailView';
import { WorkspaceSettingsMenuList } from '../WorkspaceSettingsMenuList';

interface WorkspaceSettingsContainerContentProps {
  isValidWorkspaceSetting: boolean;
  workspaceSettingNameFromURL: string;
  isOnboardingPageVariant: boolean;
}

export const WorkspaceSettingsBodyContent = ({
  isValidWorkspaceSetting,
  workspaceSettingNameFromURL,
  isOnboardingPageVariant,
}: WorkspaceSettingsContainerContentProps) => {
  if (!isValidWorkspaceSetting) {
    return (
      <Error404 message="Invalid Workspace Settings URL. Please check the link you used." />
    );
  }

  return (
    <Stack direction="row" height="100%" width="100%" spacing={4}>
      <WorkspaceSettingsMenuList
        selectedWorkspaceSetting={workspaceSettingNameFromURL}
        isOnboardingPageVariant={isOnboardingPageVariant}
      />
      <WorkspaceSettingDetailView
        selectedWorkspaceSetting={workspaceSettingNameFromURL}
      />
    </Stack>
  );
};
